<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Keyword" size="small" placeholder="请输入"></el-input>
            </div>
            <!-- <div class="item">
                <div class="label">调查任务状态:</div>
                 <el-select v-model="conditionData.auditStatus" size="small" placeholder="请选择" class="input">
                    <el-option
                    v-for="item in auditStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新建保险公司</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                prop="cClmNo"
                label="赔案号"
                align="center"
                width="260px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.cClmNo}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="personDanger"
                label="出险人"
                align="center"
                width="100px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.personDanger}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cProdType"
                label="险种类型"
                align="center"
                width="100px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.cProdType}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="companyName"
                label="保险公司名称"
                align="center"
                width="200px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.companyName}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cPlyNo"
                label="保单号"
                align="center"
                width="250px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.cPlyNo}}
                    </span>
                </template>
                </el-table-column>
                
                <el-table-column
                prop="dcTaskPgTime"
                label="派工时间"
                align="center"
                width="160px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs&&scope.row.executeAction!=50?'tb-red':''">
                        {{scope.row.dcTaskPgTime}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cSvyMode"
                label="案件时限"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.cSvyMode}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="pgTs"
                label="派工天数"
                align="center"
                width="100px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.pgTs}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cConclusion"
                label="调查结论"
                align="center"
                >
                    <template slot-scope="scope">
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-if="scope.row.cConclusion==1">正常赔付</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.cConclusion==2">减损</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.cConclusion==3">拒赔</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else>暂无结论</span>
                    </template>
                </el-table-column>
               
                <el-table-column
                prop="dispatcher"
                label="调度人"
                align="center"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.dispatcher}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="executeAction"
                label="任务状态"
                width="150px"
                align="center"
                >
                    <template slot-scope="scope">
                        <!-- <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-if="scope.row.executeAction==0">待接收</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==10">待派工</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==20">调查中</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==25">待审核</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==30">已提交</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==40">任务退回</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==50">完成</span> -->

                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-if="scope.row.executeAction==0">新任务</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==10">任务待派调查员</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==20">任务作业中</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==25">任务待机构审核</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==30">任务完成</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==40">任务退回</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==50">任务完成</span>
                        <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''" v-else-if="scope.row.executeAction==70">取消委托</span>
                    </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="detail(scope.row)">案件工作台</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>



      
        
    </div>
</template>
<script>
import api from '../../../../api/main'
import { regionData , CodeToText } from "element-china-area-data";
import { auditStatusList } from '../../../../assets/selectList/anxin'

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            auditStatusList:auditStatusList,
            title:'',
            tableData:[],
            totalCount:0,
            conditionData:{
                ExecuteAction:20,
                Keyword:'',
                auditStatus:null,
                page:1,
                pageSize:10,
            },

        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
       
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.queryDcDoubtTaskItem(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                ExecuteAction:20,
                Keyword:'',
                auditStatus:null,
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        handleCurrentChangeUser(page){
            this.userConditionData.page = page;
            this.queryUserByMechanismIds();
        },
        async auditTip(row){
            console.log(row);
            this.$confirm('是否接受此案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.examineTask(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async examineTask(row){
            let option = {
                id:row.id,
                taskSate:20
            };
            let res  = await api.examineTask(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async detail(row){
            // console.log(row);
            // this.$emit('addAnXinCase',{
            //     router:'taskRYDetail',
            //     name:'任务详情',
            //     index:'1-300',
            //     id:row.id
            // });
            // this.$router.push({
            //     name:'taskRYDetail',
            //     query:{
            //         id:row.id
            //     }
            // })

            const { href } = this.$router.resolve({
                name: "caseRYDetail",
                query:{
                    id:row.id
                }
            });
            window.open(href, '_blank');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .tb-red{
            color:red;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
